import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { SmallText, Title } from '../../../components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useSegment } from './_load/SegmentLoader'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'
import TabsMenu, { Tab } from '../../../components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation('common')
  const navigate = useNavigation()
  const segment = useSegment()

  const title = compose(capitalizeAllIfLower, prop('name'))(segment)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(segment)

  return (
    <Fragment>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <FlexCol flex={1}>
          <Title size="h4" strong color={COLORS.dark2} noMargin>
            {title}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('createdAt')} {createdAt}
          </SmallText>
        </FlexCol>
      </FlexGrid>

      <Separator weight={6} />
    </Fragment>
  )
}

export default ModalHeader
